/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import MonthlyClosingEvent from '../../event/MonthlyClosingEvent'
import { DailyClosingSummaryState } from '../state/DailyClosingSummaryState'

class DailyClosingSummaryStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new DailyClosingSummaryState()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case MonthlyClosingEvent.fetchSummary:
        if (!payload.daily_closing_summary) {
          return state
        }

        return state.mergeModel(payload.daily_closing_summary)

      default:
        return state
    }
  }
}

export default new DailyClosingSummaryStore()
